<div id="top-el"></div>
<div class="wrapper wrapper__documents box-shadow"
     [ngStyle]="deviceInnerHeight > 0 ?
        {
            'min-height': deviceInnerHeight + 'px'
        } : ''"
     [ngClass]="" [class.hidden]="isLoading">
    <span class="documents__icon" >
        <i class="documents__icon--fa overview"></i>
    </span>
    <div class="row header-title">
        <div class="col-sm-12">
            <h1 class="wrapper__title">{{ 'Your documents for the start of your therapy' | translate}}</h1>
        </div>
    </div>
    <div class="row wrapper__content">
        <div class="col-xs-12 wrapper__content__download" *ngIf="data && data.files && data.files.length > 0">
            <ng-container *ngFor="let document of data.files">
                <div class="row mt-1 wrapper__content__item">
                    <div class="col-xs-8 pd-v--sm item__name">
                        {{ document.original_file_name }}
                        <span class="col-xs-12 p-0 item__name__info" *ngIf="document.size">
                            ({{ formatBytes(document.size) }})
                        </span>
                    </div>
                    <div class="col-xs-4">
                        <button type="submit" class="btn badge-pill pd-v--sm btn-primary btn-download btn-xs-full" (click)="download(document)">
                            {{ 'Download' | translate }}
                            <i class="fal fa-download pl-1"></i>
                        </button>
                    </div>
                </div>
            </ng-container>

        </div>
        <div class="col-xs-12 mt-1">
            <div class="wrapper__content__details" >
                {{ 'As promised, we will send you all the necessary documents and we will keep our fingers crossed that you will feel better soon. In addition to the proof of diagnosis, we recommend therapy options and you will receive an evaluation of your self-assessment.' | translate }}
            </div>
        </div>
    </div>
</div>